/* eslint-disable no-useless-escape, prefer-const */
/*
 * Copyright © 2020-2023 Ocean Galaxy Inc. All Rights Reserved.
 * @Description:
 * @LastEditors: yingongjing
 * @LastEditTime: 2026-02-06 17:36:01
 */
import CONFIG from '../constants/config'

// 路径模块类型定义
interface PathModule {
  path: string
  title: string
  iconImg?: string
  iconFont?: string
  new?: boolean
  children?: PathModule[]
}

export function generateAllActiveModules(): PathModule[] {
  return CONFIG.pathModules as PathModule[]
}

function getFirstLeafModule(activeModule: PathModule): PathModule {
  if (activeModule.children && activeModule.children.length) {
    return getFirstLeafModule(activeModule.children[0])
  }
  return activeModule
}

export function getDefaultActiveModule(
  activeModules: PathModule[]
): PathModule {
  return getFirstLeafModule(activeModules[0])
}

function getBestMatchModuleRecursive(
  activeModules: PathModule[] = [],
  pathname: string
): PathModule | null {
  for (let activeModule of activeModules) {
    if (activeModule.children && activeModule.children.length) {
      const matchModule = getBestMatchModuleRecursive(
        activeModule.children,
        pathname
      )
      if (matchModule) {
        return matchModule
      }
    }

    // if (pathname.indexOf(activeModule.path) !== -1) {
    //   return activeModule
    // }
    if (pathname === activeModule.path) {
      return activeModule
    }
  }
  return null
}

export function getBestMatchModulePath(
  activeModules: PathModule[],
  pathname: string
): string | string[] {
  const matchModule = getBestMatchModuleRecursive(activeModules, pathname)
  if (/^\/data\/statistics\??[^\/]*$/.test(pathname)) {
    return ['/data/statistics']
  } else if (/^\/ai\/photo\/search\??[^\/]*$/.test(pathname)) {
    return ['/ai/photo/search']
  } else if (/\/verifyAuth(\/[^\/]+){1,3}|\/verification/.test(pathname)) {
    return ['/verifyAuth/index']
  } else if (/\/photo\/folder\/detail\/\d+/.test(pathname)) {
    // 旧详情路径已重定向到 /ai-classify/folder/:id，菜单高亮统一走新版入口
    return ['/ai-classify']
  } else if (/^\/photo\/jigsaw\??[^\/]*$/.test(pathname)) {
    return ['/photo/jigsaw']
  } else if (/^\/photo\/ai\??[^\/]*$/.test(pathname)) {
    return ['/photo/ai']
  } else if (/^\/photo\/ai-tags\??[^\/]*$/.test(pathname)) {
    return ['/photo/ai']
  } else if (/^\/watermark\/editor\??[^\/]*$/.test(pathname)) {
    return ['/watermark/list']
  } else if (/^\/rectify\/list\??[^\/]*$/.test(pathname)) {
    return ['/rectify/list'] // 添加这一行处理整改记录路径
  } else if (/^\/ai\/security\??[^\/]*$/.test(pathname)) {
    return ['/ai/security'] //
  } else if (/^\/credit($|\/|\?)/.test(pathname)) {
    return ['/credit']
  } else if (/^\/member\/track($|\/|\?)/.test(pathname)) {
    // 实时轨迹按管理员控制前端硬加,不在后端 activeModules 里,递归匹配会落空 →
    // 兜底到 /photo/all。这里显式接住,让侧边栏「实时轨迹」高亮(含回放 query 子态,
    // pathname 仍为 /member/track)。
    return ['/member/track']
  } else if (/^\/ai\/duplicate-photo($|\/|\?)/.test(pathname)) {
    return '/ai/duplicate-photo'
  } else if (/^\/today-claw($|\/|\?)/.test(pathname)) {
    return '/today-claw'
  } else if (/^\/myse\/orders($|\/|\?)/.test(pathname)) {
    return ['/myse/orders']
  } else if (/^\/myse\/check-records($|\/|\?)/.test(pathname)) {
    // 检查项管理子菜单不在 CONFIG.pathModules 里(菜单项在 SideComponent 动态装配),
    // 递归精确匹配会落空 → 兜底到 /photo/all。这里显式前缀接住,让侧边栏高亮对应子菜单
    // 而非"全部照片"(对齐 origin/master)。
    return ['/myse/check-records']
  } else if (/^\/myse\/projects($|\/|\?)/.test(pathname)) {
    return ['/myse/projects']
  } else if (/^\/myse\/downloads($|\/|\?)/.test(pathname)) {
    return ['/myse/downloads']
  } else if (/^\/myse\/simulate($|\/|\?)/.test(pathname)) {
    // 模拟检测无独立菜单项,归属"检查项配置"(对齐 origin/master)。
    return ['/myse/projects']
  } else if (/^\/myse\/knowledge-base($|\/|\?)/.test(pathname)) {
    return ['/myse/knowledge-base']
  } else if (/^\/mingyang-ai\/analysis($|\/|\?)/.test(pathname)) {
    // AI 分析(明阳智能)菜单项在 SideComponent 动态装配、不在 CONFIG.pathModules 里,
    // 递归精确匹配会落空 → 兜底到 /photo/all。显式接住,让侧边栏「AI 分析」高亮(对齐 origin/master)。
    return ['/mingyang-ai/analysis']
  } else if (/^\/ai-classify($|\/|\?)/.test(pathname)) {
    // 分类文件夹的子路由(相册详情 /ai-classify/folder/:id、未分类 /ai-classify/unclassified
    // 等)在 CONFIG.pathModules 里只登记了 /ai-classify 根路径,递归精确匹配会落空 →
    // 兜底到 /photo/all。这里显式前缀接住,让进入分类文件夹相册时侧边栏高亮"分类文件夹"
    // 而非"全部照片"(对齐 origin/master)。
    return ['/ai-classify']
  } else if (/^\/ai\/clerk($|\/|\?)/.test(pathname)) {
    // /ai/clerk 不在 CONFIG.pathModules 里,递归匹配会落空 → fallback 到 /photo/all。
    // 这里显式接住,让侧边栏的"AI 填表员"高亮跟实际路由一致。
    return '/ai/clerk'
  } else if (
    //匹配不到的情况下，返回 全部照片
    !matchModule ||
    matchModule.path === '/' ||
    matchModule.path === '/photo'
  ) {
    return ['/photo/all']
  }

  return matchModule ? matchModule.path : ''
}
